import { type SessionIngestionSummary } from "@/shared/domain/sessions";
import { type BadgeVariant } from "@/shared/foundation/primitives";

export interface SessionBadge {
  label: string;
  variant: BadgeVariant;
}

/**
 * A complete session's badge from its ingestion counts. The session page and
 * the sessions list both use it, so they always say the same thing.
 */
export function completeSessionBadge(
  summary: Pick<
    SessionIngestionSummary,
    | "state"
    | "ingested_file_count"
    | "pending_file_count"
    | "skipped_file_count"
    | "failed_file_count"
  >,
): SessionBadge {
  if (summary.state === "processing") {
    return summary.failed_file_count > 0
      ? { label: "Complete · ingestion failed", variant: "error" }
      : { label: "Complete · ingesting", variant: "warning" };
  }
  if (summary.ingested_file_count === 0 && summary.pending_file_count === 0) {
    return { label: "Complete · nothing to ingest", variant: "secondary" };
  }
  const skipped = summary.skipped_file_count;
  return {
    label:
      skipped > 0 ? `Fully ingested · ${skipped} skipped` : "Fully ingested",
    variant: "success",
  };
}
